var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pieChart",staticClass:"container",attrs:{"id":_vm.echarts}})
}
var staticRenderFns = []

export { render, staticRenderFns }